import React from 'react';

import { useQuery } from '@apollo/client';
import Box from '@material-ui/core/Box';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { GET_CATEGORIES_BY_PARENT } from '../../graphql/videos';
import { Loader } from '../Loader';
import useStyles from './styles';

const Categories = ({ parentId }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { data, loading, error } = useQuery(GET_CATEGORIES_BY_PARENT, {
    variables: {
      parent_id: parentId,
    },
  });

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        {t('error.error')}: {error?.message}
      </div>
    );
  }

  const categories = data?.listVideoCategories;

  return (
    <Box className={classes.container}>
      <div className={classes.itemsWrapper}>
        {categories.map((item) => {
          return (
            <div key={item.title} className={cx('video-subcategory', classes.item)}>
              {item.title}
            </div>
          );
        })}
      </div>
    </Box>
  );
};

export default Categories;
